import {Text} from '@dropbox/dig-components/typography';
import {atoms} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {WorkstreamsLine} from '@dropbox/dig-icons/assets';
import {NotificationCard} from 'components/notifications/NotificationCard';
import {useNotificationContext} from 'components/notifications/utils/useNotificationContext';
import {TimeAgo} from 'components/shared/TimeAgo';
import {useEmployee} from 'hooks/useEmployee';
import {t} from 'i18next';
import {Trans} from 'react-i18next';
import {useWorkstream} from 'views/workstreams/hooks';

export const WorkstreamAccess = () => {
  const {
    notification: {archived, data, updated_at},
  } = useNotificationContext();
  const {content, to, cta, data: dataString} = data;

  const jsonData = JSON.parse(dataString);

  const {workstream} = useWorkstream(parseInt(jsonData.workstream_id, 10));
  const {employee} = useEmployee({ldap: jsonData.requester_id});

  return (
    <NotificationCard
      accessory={<UIIcon src={WorkstreamsLine} className={atoms({color: 'Text Subtle'})} />}
      header={
        archived ? (
          `Review access for ${workstream?.name ?? 'workstream'}`
        ) : (
          <Trans
            i18nKey={content}
            t={t}
            values={{
              name: employee?.name ?? 'employee',
              workstream: workstream?.name ?? 'a workstream',
            }}
            components={{b: <Text isBold />}}
          />
        )
      }
      subtext={<TimeAgo timestamp={updated_at} />}
      buttonLink={{cta, to}}
      archived={archived}
    />
  );
};
